
require('browsernizr/test/css/flexbox');
require('browsernizr/test/css/mediaqueries');
require('browsernizr/test/css/transitions');

module.exports = require('browsernizr');

